import {api} from './SubAreas.generated';

export const injectedRtkApi = api.enhanceEndpoints({
  addTagTypes: ['SubAreas'],
  endpoints: {
    SubAreas: {
      providesTags: ['SubAreas'],
    },
    CreateSubArea: {
      invalidatesTags: ['SubAreas'],
    },
    SoftDeleteSubArea: {
      invalidatesTags: ['SubAreas'],
    },
  },
});

export {injectedRtkApi as api};
